// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__E4c5r","filesListContainer":"PosDisputesFiles_filesListContainer__1yNGe","filesButton":"PosDisputesFiles_filesButton__2RUS9"};